// extracted by mini-css-extract-plugin
export default {"box":"AssuranceComponent_box__dZgX0","img_box":"AssuranceComponent_img_box__HHBSk"};